import { AgentManager } from './wallet.model';
import { MonnifyUser } from './savings.model';

export interface profileCard {
	nameOne: string;
	valueOne: string;
	nameTwo: string;
	valueTwo: string;
}

export interface profileSummary {
	content: profileCard[];
	title: string;
	actionName: string;
	action: string;
	loading: boolean;
	error: string;
}

export interface nextOfKinData {
	addressLineOne: string;
	addressLineTwo: string;
	city: string;
	countryId: number;
	emailAddress: string;
	fullName: string;
	id: number;
	localGovernmentId: number;
	stateId: number;
	phoneNumber: string;
	relationship: string;
}

export interface Profile {
	addressLineOne: string;
	addressLineTwo: string;
	airtimeTransactionLimit: number;
	bankAccountNo: string;
	bankId: number;
	phoneNumber: string;
	bankVerificationNo: string;
	billPaymentTransactionLimit: number;
	businessCode: string;
	businessId: number;
	businessName: string;
	cashoutTransactionLimit: number;
	city: string;
	countryId: number;
	dateOfBirth: string;
	depositTransactionLimit: number;
	displayAccountBalance: boolean;
	emailAddress: string;
	firstName: string;
	gender: string;
	jobTitle: string;
	lastName: string;
	localGovernmentId: number;
	meansOfIdentification: string;
	mobileNumber: string;
	mothersMaidenName: string;
	nextOfKinData: nextOfKinData;
	occupation: string;
	printMerchantCopy: boolean;
  receiptReprintEnabled?:boolean;
	stateId: number;
	username: string;
	withdrawalTransactionLimit: number;
	singleCashoutTransactionLimit: number;
	dailyCashoutLimit: number;
}

export interface ProfileRequestModel {
	profile: Profile;
	responseCode: string;
	agentManager: AgentManager;
	user: MonnifyUser;
}

export interface ProfilePinResponse {
	access_token: string;
	authorities: string[];
	email: string;
	expires_in: number;
	firstName: string;
	lastName: string;
	roles: string[];
	username: string;
}

export class UpdateAgentProfileRequest {
	emailAddress: string;
	mobileNumber: string;
	phoneNumber: string;
	username:string;
	imageOne?: File;
	imageTwo?: File;
	pin?: string;
}

export class UpdateOutletAgentLivelinessRequest {
  imageOne?: File;
  imageTwo?: File;
  pin?: string;
}

export class UpdateNextOfKinRequest {
	addressLineOne: string;
	addressLineTwo: string;
	city: string;
	countryId: number;
	emailAddress: string;
	fullName: string;
	localGovernmentId: number;
	nextOfKinContext: string;
	phoneNumber: string;
	relationship: string;
	stateId: number;
	id: number;
}

export interface EmploymentDetails {
	aggregator: string;
	aggregatorId: number;
	authorizer: string;
	comment: string;
	employeeContractReference: string;
	employeeContractStatus: string;
	id: number;
}


